import { Injectable, signal, WritableSignal} from '@angular/core';
import { loadContent } from '../configs/content';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  lang: WritableSignal<string> = signal('en');
  langText: WritableSignal<string> = signal('english');
  dir: WritableSignal<string> = signal('ltr');
  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  private updateDocumentLanguage(lang: string, dir: string) {
    console.log('updateDocumentLanguage', lang, dir)
    // document.documentElement.lang = lang;
    // document.documentElement.dir = lang === 'en' ? 'ltr' : 'rtl';
  }

  async toggleLanguage() {
    this.langText.set('english');
    this.lang.set('en');
    this.dir.set('ltr');
    this.updateLocalStorage('en', 'ltr', 'english');
    this.updateDocumentLanguage('en', 'ltr');
  }

  updateLocalStorage(lang: string, dir: string, langText: string) {
    if (typeof window !== 'undefined') {
      localStorage.setItem('lang', lang);
      localStorage.setItem('dir', dir);
      localStorage.setItem('langText', langText);
    }
  }

  getLocalStorage() {
    if (typeof window !== 'undefined') {
      return {
        lang: localStorage.getItem('lang') || 'en',
        dir: localStorage.getItem('dir') || 'ltr',
        langText: localStorage.getItem('langText') || 'english'
      };
    }
    return { lang: 'en', dir: 'ltr', langText: 'english' };
  }

  async loadContent(page: string): Promise<any> {
    const local: any = this.getLocalStorage();
    if (local.lang) {
      this.lang.set('en');
      this.dir.set('ltr');
      this.langText.set('english');
      this.updateDocumentLanguage('en', 'ltr');
    }
    try {
      return await loadContent(page, this.lang());
    } catch (error) {
      console.error('Error loading content:', error);
      throw error;
    }
  }

  initializeApp() {
    const local: any = this.getLocalStorage();
    console.log('local $', local)
    this.updateDocumentLanguage('en', 'ltr');
    this.translate.use('en');
    this.lang.set('en');
    this.dir.set('ltr');
    this.langText.set('english');
    this.updateLocalStorage('en', 'ltr', 'english');
  }
}
